import React, { useEffect, useRef } from 'react';
import { ReactComponent as TabLogoW } from 'img/logos/tab-logo-w.svg';
import { ReactComponent as TabLogoWsf } from 'img/logos/tab-logo-wsf.svg';
import { ReactComponent as TabLogoOktoberfest } from 'img/logos/tab-logo-oktoberfest.svg';
import { ReactComponent as TabLogoHolidayMagic } from 'img/logos/tab-logo-holiday-magic.svg';
import { ReactComponent as TabLogoWsfSpring } from 'img/logos/tab-logo-wsf-spring.svg';
import { ReactComponent as TabLogoTaste } from 'img/logos/tab-logo-taste.svg';
import { ReactComponent as TabLogoFoundation } from 'img/logos/tab-logo-foundation.svg';
import { useSiteSectionNavigationData } from "hooks/use-site-section-navigation-data"

type TabbedLogoBarProps = {
    tab: string;
};

const TabbedLogoBar: React.FC<TabbedLogoBarProps> = ({ tab }) => {
    const navData = useSiteSectionNavigationData();
    const tabs = [
        { name: 'wsfec', sectionNavLogoData: navData.wsfecNavigation.navLogo, logo: <TabLogoW /> },
        { name: 'wsf', sectionNavLogoData: navData.stateFairNavigation.navLogo, logo: <TabLogoWsf /> },
        { name: 'oktoberfest', sectionNavLogoData: navData.oktoberfestNavigation.navLogo, logo: <TabLogoOktoberfest /> },
        { name: 'holiday-magic', sectionNavLogoData: navData.holidayMagicNavigation.navLogo, logo: <TabLogoHolidayMagic /> },
        { name: 'wsf-spring', sectionNavLogoData: navData.springFairNavigation.navLogo, logo: <TabLogoWsfSpring /> },
        { name: 'taste', sectionNavLogoData: navData.tasteNwLanding.navLogo, logo: <TabLogoTaste /> },
        { name: 'foundation', sectionNavLogoData: navData.foundationNavigation.navLogo, logo: <TabLogoFoundation /> },
    ];

    const tabbedLogoBarRef = useRef(null);

    useEffect(() => {
        const activeTabLogo = tabbedLogoBarRef.current?.querySelector('.tabbed-logo-bar li.active');
        if (activeTabLogo) {
            tabbedLogoBarRef.current.scrollLeft = activeTabLogo.offsetLeft;
        }
    }, []);

    return (
        <div className="tabbed-logo-bar">
            <div ref={tabbedLogoBarRef} className="tabbed-logo-bar__scroll">
                <div className="container">
                    <ul role="list">
                        {tabs.map((tabInfo) => (
                            <li className={tab === tabInfo.name ? 'active' : ''} key={tabInfo.name}>
                                <a href={tabInfo.sectionNavLogoData.path}>
                                    {tabInfo.logo}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="tabbed-logo-bar__scroll-indicator"></div>
        </div>
    );
};

export default TabbedLogoBar;